import TextInput from "./TextInput";
import CheckboxInput from "./CheckboxInput";
import TimeInput from "./TimeInput";
const DayShiftRow = ({ day, value, onChange }) => {
  const IsRestDay = value?.IsRestDay ?? false;

  const calculateBreakMinutes = (start, end) => {
    if (!start || !end) return 0;
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    return eh * 60 + em - (sh * 60 + sm);
  };

  const update = (updates) => {
    const updated = { ...value, ...updates };

    if (updated.BreakStartTime && updated.BreakEndTime) {
      updated.BreakDurationMinutes = calculateBreakMinutes(
        updated.BreakStartTime,
        updated.BreakEndTime
      );
    }

    onChange(updated);
  };

  return (
    <div className="shift-day-row">
      <div className="shift-day-row__header">
        <strong>{day}</strong>

        <CheckboxInput
          label="Rest Day"
          checked={IsRestDay}
          onChange={(_, checked) =>
            checked
              ? onChange({
                  id: value?.id || null,
                  IsRestDay: true,
                  StartTime: value?.StartTime || "",
                  EndTime: value?.EndTime || "",
                  BreakStartTime: value?.BreakStartTime || "",
                  BreakEndTime: value?.BreakEndTime || "",
                  BreakDurationMinutes: value?.BreakDurationMinutes || 0,
                })
              : onChange({
                  id: value?.id || null,
                  IsRestDay: false,
                  StartTime: value?.StartTime || "",
                  EndTime: value?.EndTime || "",
                  BreakStartTime: value?.BreakStartTime || "",
                  BreakEndTime: value?.BreakEndTime || "",
                  BreakDurationMinutes: value?.BreakDurationMinutes || 0,
                })
          }
        />
      </div>

      {!IsRestDay && (
        <div className="shift-day-row__body">
          <div className="shift-day-row__grid">
            <TimeInput
              label="Start Time"
              type="time"
              value={value?.StartTime || ""}
              onChange={(val) => update({ StartTime: val })}
            />

            <TimeInput
              label="End Time"
              type="time"
              value={value?.EndTime || ""}
              onChange={(val) => update({ EndTime: val })}
            />

            <TimeInput
              label="Break Start"
              type="time"
              value={value?.BreakStartTime || ""}
              onChange={(val) => update({ BreakStartTime: val })}
            />

            <TimeInput
              label="Break End"
              type="time"
              value={value?.BreakEndTime || ""}
              onChange={(val) => update({ BreakEndTime: val })}
            />

            <TextInput
              label="Break (minutes)"
              value={value?.BreakDurationMinutes || 0}
              disabled
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DayShiftRow;
